export default {
    en: {
        id: 'diagram4c2-3',
        blocks: [
            {
                task: 'S = Want to sell 40 acres of property in Oklahoma, valued at $2.66k. But first must clean up the land and buldings, contaminated with abstestos. Cost is $350,000',
                title: "S = ",
                answer: 'Need to do X',
                modelName: 's'
            },
            {
                task: 'C = The $350,000 can be either expensed or capitalized ',
                title: "C = ",
                answer: 'Have two choices of how',
                modelName: 'c'
            },
            {
                task: 'Q = Which?',
                title: "Q = Which",
                answer: ' ',
                disableEdit: true
            }
        ],
        title: 'Type in roughly what the Situation and Complication should say',
        note: `
        Whenever you have alternatives, they always go in the Complication, and the Question is always Which? You never bring up alternatives simply to reject them.
        They must always be known in advance by the reader (or accepted as true), and the purpose of the document is to present the argument for the alternative chosen.
        This particular document argues for doing both alternatives. The more likely situation is that you will be comparing alternatives, selecting one, and arguing why that alternative is better than others.
        `
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4c2/practiceInSeeing3/i18n/exercise3.js